import React, { Component } from 'react'
import { compose } from 'recompose'

import { LayoutPlain, Header, Footer } from 'components/layout'
import { Login, Register } from 'containers/forms/auth'
import { meta } from 'helpers/decorators'

import { apiAnnouncements } from 'helpers/decorators/api'

import { Banner, Announcement } from 'components/misc'
import PropTypes from 'prop-types'
import MfaCodeModal from '../../../components/modals/MfaCodeModal/MfaCodeModal'
import MODALS from '../../../constants/layout/modals'

const enhance = compose(
  meta({
    title: 'Landing page',
    intlKey: 'route.landing_page'
  }),
  apiAnnouncements()
)

class Home extends Component {
  static propTypes = {
    announcements: PropTypes.object
  }

  render() {
    const { announcements } = this.props

    return (
      <LayoutPlain
        header={<Header />}
        footer={<Footer />}
        banner={<Banner />}
        announcement={<Announcement announcements={announcements} />}
         body={[<Login {...this.props} />, <Register {...this.props} />]}
        colWidth="320px"
        divider
      >
        <MfaCodeModal modalId={MODALS.SET_MFA_CODE} />
      </LayoutPlain>
    )
  }
}

export default enhance(Home)
